export enum QuoteProductTypeEnum {
  CREDIT = 0,
  LEASING = 1,
  LEASING_RESIDUAL = 2
}

export enum VehicleAssetTypeEnum {
  NEW = 0,
  USED = 1,
}

export enum InsurancePaymentMethodEnum {
  CASH = 0,
  FINANCED = 1,
}

export enum IncomeMethodEnum {
  MANUAL = 0,
  AI_ESTIMATE = 1,
}

export enum SegmentedProductIndex {
  CREDIT = 0,
  LEASING = 1,
  LEASING_RESIDUAL = 2,
}

export enum PersonRegimeType {
  PERSONA_FISICA = "pf",
  PERSONA_FISICA_ACTIVIDAD_EMPRESARIAL = "pfae",
  PERSONA_MORAL = "pm",
}

// String values for each enum type
export const QuoteProductTypeValues: Record<QuoteProductTypeEnum, string> = {
  [QuoteProductTypeEnum.CREDIT]: "credit",
  [QuoteProductTypeEnum.LEASING]: "leasing",
  [QuoteProductTypeEnum.LEASING_RESIDUAL]: "leasing_residual",
};

export const VehicleAssetTypeValues: Record<VehicleAssetTypeEnum, boolean> = {
  [VehicleAssetTypeEnum.NEW]: true,
  [VehicleAssetTypeEnum.USED]: false,
};

export const InsurancePaymentMethodValues: Record<InsurancePaymentMethodEnum, string> = {
  [InsurancePaymentMethodEnum.CASH]: "contado",
  [InsurancePaymentMethodEnum.FINANCED]: "financiado",
};

export const IncomeMethodValues: Record<IncomeMethodEnum, string> = {
  [IncomeMethodEnum.MANUAL]: "manual",
  [IncomeMethodEnum.AI_ESTIMATE]: "ai_estimate",
};
